import { combineReducers } from 'redux'
import reduceReducers from 'reduce-reducers'
import { handleActions } from 'redux-actions'
import _ from 'lodash'
import * as modules from './modules'
import {
  initialState as timelineInit,
  CHANGE_YEAR,
  SELECT_TOPIC,
} from './modules/timeline'
import { initialState as mapInit } from './modules/map'
import { DEACTIVATE } from './interactionReducer'
import interactionReducer from './interactionReducer'

const setCompanyProfileVisibility = state => {
  const { showProfile, items: companies } = state.companies
  const { current: year } = state.timeline

  return {
    ...state,
    companies: {
      ...state.companies,
      showProfile: _.transform(
        showProfile,
        (result, value, key) => {
          const { start, end } = companies[key]
          const visible = start <= year && end >= year
          result[key] = showProfile[key] && visible
        },
        {}
      ),
    },
  }
}

const resetState = state => {
  const { latitude, longitude, zoom } = mapInit.viewport
  const { current, selectedTopicID } = timelineInit
  return _.merge({}, state, {
    companies: {
      showProfile: _.mapValues(state.companies.showProfile, () => false),
      expandedProfile: null,
    },
    timeline: { current, selectedTopicID },
    map: { viewport: { latitude, longitude, zoom } },
  })
}

export const crossSliceReducer = handleActions(
  {
    // Close opened company profiles if they do not exist in current year
    [CHANGE_YEAR]: setCompanyProfileVisibility,
    [SELECT_TOPIC]: setCompanyProfileVisibility,
    [DEACTIVATE]: resetState,
  },
  {}
)

const combinedReducer = combineReducers({
  ...modules,
  system: interactionReducer,
})

const rootReducer = reduceReducers(combinedReducer, crossSliceReducer)

export default rootReducer
